import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import { $gitShow } from "../../internal/git";

/**
 * Hook to show details of a specific commit
 * @param documentId - The document ID
 * @param commitHash - The commit hash to show
 * @returns The commit details or undefined if not available
 */
export const useGitShow = (documentId: string | undefined, commitHash: string) => {
	const showAtom = $gitShow({ documentId, commitHash });
	const showLoadable = useAtomValue(loadable(showAtom));
	const refresh = useSetAtom(showAtom);

	return {
		data: showLoadable.state === "hasData" ? showLoadable.data : undefined,
		refresh,
		isLoading: showLoadable.state === "loading",
		isError: showLoadable.state === "hasError",
	};
};
